export function instanceOf<T>(object: any, member: string): object is T {
  return member in object
}
